const HistoryIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_1681_1318" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
            <rect width="48" height="48" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_1681_1318)">
            <path d="M7 42.7385V5.26147L9.7695 7.72298L12.6155 5.26147L15.4615 7.72298L18.3075 5.26147L21.154 7.72298L24 5.26147L26.846 7.72298L29.6925 5.26147L32.5385 7.72298L35.3845 5.26147L38.2305 7.72298L41 5.26147V42.7385L38.2305 40.277L35.3845 42.7385L32.5385 40.277L29.6925 42.7385L26.846 40.277L24 42.7385L21.154 40.2815L18.3075 42.7385L15.4615 40.2815L12.6155 42.7385L9.7695 40.2815L7 42.7385ZM12.3885 32.296H35.754V30.027H12.3885V32.296ZM12.3885 25.1345H35.754V22.8655H12.3885V25.1345ZM12.3885 17.923H35.754V15.654H12.3885V17.923ZM9.2695 38.7075H38.7305V9.29247H9.2695V38.7075Z" fill="currentColor" />
        </g>
    </svg>

);

export default HistoryIcon;
